// Module
var code = "<label> <span data-bind=\"text: Name\"></span> <input data-bind=\"checked: Value, attr:{name: Type, disabled: !IsEnabled()}\" type=\"checkbox\"> </label> ";
// Exports
export default code;